/**
 * Answer sets shared between the step that first asks a question and the review
 * page, which lets the customer change the same answer.
 */

/**
 * NOTE: the Figma export lists "Immediately" twice and never names a second
 * timeframe. "Within 1 month" is a stand-in that fits the progression — worth
 * confirming against the intended copy.
 */
export const TIMELINE_OPTIONS = [
  { value: "immediately", label: "Immediately" },
  { value: "within-1-month", label: "Within 1 month" },
  { value: "within-2-3-months", label: "Within 2-3 months" },
  { value: "exploring", label: "Just exploring for now" },
];

// The design shows "1 shareholder" selected; the full option list isn't
// specified, so this is a sensible range.
export const SHAREHOLDER_OPTIONS = [
  "1 shareholder",
  "2 shareholders",
  "3 shareholders",
  "4 shareholders",
  "5 or more shareholders",
];
